import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { UsedSgkd020dSgkd034aService } from '../services/used-sgkd020d-sgkd034a.service';

import {
  Sgkd050aService,
  Sgkd050aRequest,
  Sgkd050aRequestDto,
  Sgkd050aResponse
} from 'sg-api';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';
import { Sgkd020dRegistInfo } from '../models/sgdk020d-regist_info';
import { split } from 'lodash';

/** 不備理由テーブル選択行の種別・コードペア */
export interface HubirsnItem {
  /** 不備理由種別 */
  clsfy: string;
  /** 不備理由コード */
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd050aService {

  private _rsesult$ = new Subject<Sgkd050aResponse>();
  businessDate: any;

  constructor(
    private sgkd050aService: Sgkd050aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKD050A_口振・クレ申込受付登録更新API呼び出し
   *
   * @param searchInfo searchForm.value
   * @param searchInfo searchInfoForm.value
   * @param searchInfo fubiReasonForm.value
   * @param hubirsnList テーブル選択行の種別・コードペア（最大26件）
   */
  doSgkd050a(registInfo: Sgkd020dRegistInfo, searchInfo: any, hubirsnList: HubirsnItem[]): Observable<Sgkd050aResponse> {

    //let address = split(searchInfo.moshikomi,'/r',9)

    const dto: Sgkd050aRequestDto = {
      // search フォーム
      koshinFlg:                    registInfo.koshinFlg,
      firstSrvctrNo:                registInfo.firstSrvctrNo,
      recptFixNo:                   registInfo.recptFixNo,
      payMthdiv:                    registInfo.payMthdiv,
      // kouza-info フォーム         
      kohuricreMskmaceptMno:        registInfo.kohuricreMskmaceptMno,
      aceptState:                   searchInfo.aceptState,
      visitKinyuno:                 searchInfo.visitKyhNo,
      bankfcCode:                   searchInfo.bankfcCode,
      brnccd:                       searchInfo.branchCode,
      bankfcMei:                    searchInfo.bankfcMei,
      branchname:                   searchInfo.branchMei,
      dptClsfy:                     searchInfo.dptcls,
      kouzaNo:                      searchInfo.accntn,
      mozmigKnjnm:                  searchInfo.mozmigKanji,
      mozmigKananame:               searchInfo.mozmigKana,
      crdKananame:                  searchInfo.crdKananame,
      crdCompanycode:               searchInfo.cregitCoCode,
      databaseKey:                  searchInfo.dbKey,
      // fubi-reason フォーム
      depositpersonMeigiDiff:       searchInfo.dptprsMeigiDiff,
      etcHubirsn:                   searchInfo.etcHubirsn,
      ctrerMei:                     searchInfo.ctrerMei,
      postno:                       searchInfo.postno,
      prefectureaname:              searchInfo.prefectureaname,
      administrativecitywardname:   searchInfo.administrativecitywardname,
      choname:                      searchInfo.choname,
      chome:                        searchInfo.chome,
      buildingnumber:               searchInfo.buildingnumber,
      visitSupadrAname:             searchInfo.visitSupadrAname,
      visitYagouAname:              searchInfo.visitYagouAname,
      remarks:                      searchInfo.remarks,
    };

    // 不備理由種別・コードを最大26件セット
    hubirsnList.slice(0, 26).forEach((item, i) => {
      (dto as any)[`hubirsnClsfy${i + 1}`] = item.clsfy;
      (dto as any)[`hubirsnCode${i + 1}`]  = item.code;
    });

    const request: Sgkd050aRequest = { requestDto: dto };

    return this.sgkd050aService.doSGKD050APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(response => {
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD050A');
          return throwError(err.message);
        })
      );
    }
  }
